import { createRouter, createWebHistory } from "vue-router";
import AdminLayout from "../layouts/AdminLayout.vue";
import DashboardView from "../views/DashboardView.vue";
import LoginView from "../views/LoginView.vue";
import InventoryView from "../views/InventoryView.vue";
import ProductCenterView from "../views/ProductCenterView.vue";
import OrdersView from "../views/OrdersView.vue";
import RefundsView from "../views/RefundsView.vue";
import CustomizationsView from "../views/CustomizationsView.vue";
import CustomOptionPresetsView from "../views/CustomOptionPresetsView.vue";
import PointsProductsView from "../views/PointsProductsView.vue";
import PointsRedemptionsView from "../views/PointsRedemptionsView.vue";
import CouponsView from "../views/CouponsView.vue";
import CustomerReturnsView from "../views/CustomerReturnsView.vue";
import { isAdminAuthenticated } from "../auth/session";

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/login",
      name: "login",
      component: LoginView,
      meta: { public: true },
    },
    {
      path: "/",
      component: AdminLayout,
      children: [
        {
          path: "",
          name: "dashboard",
          component: DashboardView,
        },
        {
          path: "products",
          name: "products",
          component: ProductCenterView,
        },
        {
          path: "inventory",
          name: "inventory",
          component: InventoryView,
        },
        {
          path: "orders",
          name: "orders",
          component: OrdersView,
        },
        { path: "refunds", name: "refunds", component: RefundsView },
        { path: "customizations", name: "customizations", component: CustomizationsView },
        { path: "custom-option-presets", name: "custom-option-presets", component: CustomOptionPresetsView },
        { path: "points-products", name: "points-products", component: PointsProductsView },
        { path: "points-redemptions", name: "points-redemptions", component: PointsRedemptionsView },
        { path: "coupons", name: "coupons", component: CouponsView },
        { path: "reviews", name: "reviews", component: CustomerReturnsView },
      ],
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/",
    },
  ],
});

router.beforeEach((to) => {
  if (to.meta.public) return isAdminAuthenticated() && to.name === "login" ? { name: "dashboard" } : true;
  return isAdminAuthenticated() ? true : { name: "login", query: { redirect: to.fullPath } };
});
